import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320 172"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M320 58.828C229.5 31.297 0 76.953 0 76.953V179.72s273.302 69.621 320-9.423V58.827Z"
        fill="#D8DFFC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M186.806 18.376c-1.231 3.304-8.374 4.202-4.973 8.923.126.175.258.367.405.555 4.568 5.825 3.263 6.559-2.121 9.678-2.307 1.337-.537 4.64.81 6.456 1.346 1.815 5.324 7.745 14.072 6.459 3.915-.576 8.177-2.756 10.209-7.894 2.033-5.138-3.525-3.703-3.39-6.87.089-2.074 4.284-4.373 2.252-10.941-2.033-6.568-4.406-2.203-4.865-6.366-.459-4.162 1.501-9.514-5.775-8.548-7.276.966-5.351 5.135-6.624 8.548Z"
        fill="#B3BAF7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M193.079 61.294h1.014V18.987h-1.014v42.307Z"
        fill="#494951"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m193.612 34.419-.533-.063c.873-3.837 6.901-6.223 7.157-6.323l.255.344c-.06.023-6.051 2.396-6.879 6.042Zm-.345 11.441c-.574-2.226-4.733-3.68-4.776-3.695l.249-.296c.181.062 4.429 1.546 5.045 3.937l-.518.055Z"
        fill="#494951"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M273.204 24.615c-.988 2.664-6.717 3.39-3.989 7.196.102.142.207.297.326.448 3.663 4.698 2.616 5.29-1.702 7.806-1.851 1.079-.43 3.742.65 5.207 1.079 1.464 4.27 6.247 11.286 5.21 3.14-.465 6.558-2.224 8.189-6.368 1.63-4.144-2.828-2.986-2.72-5.54.071-1.673 3.437-3.528 1.806-8.825-1.63-5.297-3.533-1.777-3.902-5.134-.368-3.357 1.204-7.673-4.632-6.894-5.835.779-4.291 4.141-5.312 6.894Z"
        fill="#CDAFF3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M278.384 61.294h1.014V28.221h-1.014v33.073Z"
        fill="#494951"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M278.384 36.555c.872-3.837 6.9-6.223 7.156-6.323l.256.344c-.06.024-6.051 2.397-6.879 6.042l-.533-.063Zm.188 9.305c-.574-2.226-4.733-3.68-4.776-3.695l.249-.295c.181.061 4.429 1.545 5.045 3.936l-.518.055Z"
        fill="#494951"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M201.641 7.885c-.654 2.304-1.748 4.523-2.622 6.785-.899 2.329-1.807 4.697-1.796 7.124.015 3.157 1.66 6.292 4.505 8.588 1.116.899 2.417 1.685 3.276 2.735.859 1.05 1.176 2.492.217 3.49-1.384 1.44-4.345 1.128-6.368 2.027-2.548 1.133-2.902 4.02-1.45 5.975 1.453 1.956 8.068 7.55 17.507 6.165 4.225-.62 9.951-3.682 9.788-6.956-.17-3.409-4.445-6.17-4.3-9.58.096-2.234 2.068-4.122 3.775-5.94 1.707-1.818 3.298-4.033 2.512-6.186-1.157-3.17-6.518-4.15-9.114-6.78-1.672-1.693-2.04-3.92-2.144-6.038-.104-2.117-.033-4.287-.96-6.284-2.25-4.845-10.236-4.267-12.826 4.875Z"
        fill="#6E76EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M211.721 61.56h1.014V19.553h-1.014V61.56Z"
        fill="#2E2F34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m212.253 34.875-.532-.063c.872-3.81 6.898-6.178 7.153-6.278l.256.342c-.06.023-6.049 2.38-6.877 6Zm-.345 11.362c-.573-2.211-4.731-3.655-4.773-3.67l.249-.293c.18.062 4.427 1.535 5.043 3.909l-.519.054Z"
        fill="#2E2F34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.132 45.164h1.759v6.156h-1.759v-6.156Zm25.105 0h1.758v6.156h-1.758v-6.156Zm-26.427 6.444h1.759v9.601h-1.759v-9.601Zm27.749 0h1.759v9.601h-1.759v-9.601Z"
        fill="#494951"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M251.193 46.356h-31.014a.817.817 0 0 1-.813-.821v-5.578c0-.454.364-.822.813-.822h31.014c.449 0 .813.368.813.822v5.578a.817.817 0 0 1-.813.821Z"
        fill="#B186EA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M251.192 39.135h-2.442c.449 0 .814.367.814.82v5.58a.818.818 0 0 1-.814.821h2.442a.817.817 0 0 0 .813-.82v-5.58a.817.817 0 0 0-.813-.821Z"
        fill="#7A4ABB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M252.129 52.84h-32.887a1.226 1.226 0 0 1-1.219-1.232c0-.68.546-1.23 1.219-1.23h32.887c.673 0 1.219.55 1.219 1.23 0 .68-.546 1.231-1.219 1.231Z"
        fill="#B186EA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M252.127 50.378h-2.442c.674 0 1.221.55 1.221 1.23 0 .68-.546 1.232-1.221 1.232h2.442c.674 0 1.221-.552 1.221-1.232 0-.68-.547-1.23-1.221-1.23Z"
        fill="#7A4ABB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M223.353 41.46a.595.595 0 0 0-.592.6v1.034c0 .33.265.598.592.598a.596.596 0 0 0 .593-.598v-1.035a.596.596 0 0 0-.593-.598Zm24.766 0a.596.596 0 0 0-.593.6v1.034c0 .33.266.598.593.598a.595.595 0 0 0 .593-.598v-1.035a.595.595 0 0 0-.593-.598Z"
        fill="#494951"
      />
      <rect
        x={188.636}
        y={61.121}
        width={93.66}
        height={0.879}
        rx={0.44}
        fill="#727382"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h320v172H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
